import * as z from "zod";

const AttachmentSchema = z.object({
  url: z.string(),
  description: z.string(),
  mimeType: z.string(),
});

export const sendSlackMessage = {
  name: "sendSlackMessage" as const,
  input: z.object({
    message: z.string(),
    teamIds: z.array(z.string()).min(1, "At least one team must be selected"),
    attachments: z.array(AttachmentSchema).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    results: z.array(
      z.object({
        teamId: z.string(),
        channelId: z.string().optional(),
        success: z.boolean(),
        error: z.string().optional(),
      }),
    ),
  }),
};
